module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAzCAYAAADVY1sUAAAAAXNSR0IArs4c6QAAAHlJREFUaAXt2EEKwCAMBEDp/+/tb1s/sFAQ1MgInlYwTi7B1iwCBAgQIECAQDmBp1f8brQj4BWTYoGHFGuYcgkQIECAAIE/Anc/NHOojDWZtSLNouCYjizycy0BAgQIEKgpsMuPY9Q7ZkTxkNhjAQECBAgQIEBgWOADHp5ge2g2z+oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_channel.png
// module id = 466
// module chunks = 0 1 2 3 4